import Portal = require("portal-gis");
import Utils = require("../utils");
import Base = require("./base-command");
import _ = require("underscore");

class Command extends Base<any> {

    static about = `
Layer event addfeature fires for every feature added.  Invoking the popup for each feature
is causing map issues.  This command will build a collection of features before triggering.
`;

    static options = Utils.defaults({
        "feature": {
            "about": "the feature to add to the layer",
        },
        "layer": {
            "about": "layer to add to the source",
        },
    }, Base.options);


    state() {
        let modelId = `commands:synthetic-add-features:debounce`;

        let result = <{
            sources: any,
            features: any,
            debounce: Function
        }>this.mediator.model.get(modelId);

        if (!result) {
            result = {
                sources: [],
                features: [],
                debounce: _.debounce(() => {
                    let layers = result.sources.map((layer, i) => ({
                        layer: layer,
                        features: result.features[i]
                    }));

                    // clear the cache
                    result.sources = [];
                    result.features = [];
                    layers.some(li => !!li.features.length) && this.trigger({
                        syntheticHack: layers
                    });
                }, 100, false)
            };
            this.mediator.model.set(modelId, result);
        }

        return result;
    }

    execute(args: any = this.args) {
        let debouncer = this.state();
        let sources = debouncer.sources;
        let features = debouncer.features;

        let layer = this.findOption("layer");
        let i = sources.indexOf(layer);
        if (0 > i) i = sources.push(layer) - 1;
        features[i] = features[i] || [];

        let feature = this.findOption("feature");
        features[i].push(feature);

        debouncer.debounce();
    }

}

export = Command; 